import { render } from "./UserProgrammiCheckFinale.vue?vue&type=template&id=1c370ddf&scoped=true"
import script from "./UserProgrammiCheckFinale.vue?vue&type=script&lang=js"
export * from "./UserProgrammiCheckFinale.vue?vue&type=script&lang=js"

import "./UserProgrammiCheckFinale.vue?vue&type=style&index=0&id=1c370ddf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c370ddf"]])

export default __exports__